import Vue from 'vue'
import messageBox from './MessageBox.vue'

let MessageConstructor = Vue.extend(messageBox);
let instance,currentMsg;
let instances = [];
let seed = 1;

var MessageBox = function(options,callback) {
    // One Message at a time
    // Remove any existing message
    if(instances.length > 0) {
        instances.forEach((i)=> {
            if(document.body.contains(i.vm.$el))
                document.body.removeChild(i.vm.$el)
        })

        instances = []
        seed = 1
    }

    options = options || {};
    if (typeof options === 'string') {
        options = {
            message: options
        }

        if (typeof arguments[1] === 'string') {
            options.title = arguments[1];
        }
        if (arguments[2]) {
            options.mesgObj = arguments[2];
        }
    } 

    instance = new MessageConstructor({
        data: options
    });


    let id = 'message_box_' + seed++;
    instance.id = id;

    instance.vm = instance.$mount();
    document.body.appendChild(instance.vm.$el);

    instances.push(instance);
    return instance.vm;
}


export default MessageBox;


// WEBPACK FOOTER //
// ./src/components/MovedFromVueStyleGuide/MessageBox/index.js